import { UserRole } from "tm-shared/types";

export interface MarketVerifyAddressCapabilities {
    canVerifyAddress: boolean;
}

export const getMarketVerifyAddressCapabilities = (
    role: UserRole,
): MarketVerifyAddressCapabilities => ({
    canVerifyAddress: role === UserRole.Sv || role === UserRole.Svm,
});
